

// window.initializeCartAddOnSwiper = function () {
//   var swiper = new Swiper(".add-on-item", {
//     slidesPerView: 1,
//     spaceBetween: 10,
//     centeredSlides: false,
//     navigation: {
//       nextEl: '.next',
//       prevEl: '.prev',
//     },
//     breakpoints: {
//       320: {
//         slidesPerView: 1,
//       },
//       1500: {
//         slidesPerView: 1.5,
//       },
//     },
//   });

//   const addOnSection = document.querySelector(".add_on_section");
//   if (addOnSection && addOnSection.children.length === 0) {
//     addOnSection.remove();
//   }
// };

// // Call the function when the page loads
// document.addEventListener("DOMContentLoaded", function () {
//   window.initializeCartAddOnSwiper();
// });

// $(document).on("click", ".check_btn", function () {
//   setTimeout(() => {
//     if (typeof window.initializeCartAddOnSwiper === "function") {
//       window.initializeCartAddOnSwiper();
//     }
//   }, 1000); // Adjust timeout as needed
// });

// $(document).on("click", ".check_btn", function () {
//   setTimeout(() => {
//     $(".cart-count-bubble").load(location.href + " .cart-count-bubble");
//   }, 1000); // Adjust timeout as needed
// });

// // if (
// //   window.performance &&
// //   window.performance.navigation.type ==
// //     window.performance.navigation.TYPE_BACK_FORWARD
// // ) {
// //   setTimeout(() => {
// //     $(".cart-count-bubble").load(location.href + " .cart-count-bubble");
// //   }, 500); // Adjust timeout as needed
// // }


// document.addEventListener("DOMContentLoaded", function () {
//   const searchLabel = document.getElementById("searchLabel");

//   // Placeholder texts to cycle through
//   const placeholders = [
//     "Commercial Flags",
//     "Stick Flags",
//     "Residential Flagpoles",
//     "American Flags",
//   ];

//   let index = 0; // Tracks which word is being typed
//   let charIndex = 0; // Tracks character position
//   let isDeleting = false; // Typing forward or deleting backward
//   let speed = 50; // Typing speed
  

//   function typeEffect() {
//     let currentText = placeholders[index];
//     let displayText = currentText.substring(0, charIndex);
//     searchLabel.textContent = displayText; // Update label text

//     if (!isDeleting) {
//       charIndex++;
//       if (charIndex > currentText.length) {
//         isDeleting = true;
//         speed = 200; // Pause before deleting
//       }
//     } else {
//       charIndex--;
//       speed = 150; // Speed up deleting
//       if (charIndex === 0) {
//         isDeleting = false;
//         index = (index + 1) % placeholders.length; // Move to next word
//         speed = 100; // Pause before typing new word
//       }
//     }

//     setTimeout(typeEffect, speed);
//   }

//   typeEffect(); // Start animation
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var peopleAlsoBought = document.querySelector(".related-products");
//   var desktopContainer = document.querySelector(".you-may-also");
//   var mobileContainer = document.querySelector(".you-may-also-mobile");

//   if (peopleAlsoBought) {
//     if (desktopContainer) {
//       desktopContainer.appendChild(peopleAlsoBought.cloneNode(true)); // Clone for desktop
//     }
//     if (mobileContainer) {
//       mobileContainer.appendChild(peopleAlsoBought.cloneNode(true)); // Clone for mobile
//     }
//   }
// });



// window.collection_search = function () {

//   const searchLabel = document.getElementById("collection_searchLabel");

//   // Placeholder texts to cycle through
//   const placeholders = [
//     "Commercial Flags",
//     "Stick Flags",
//     "Residential Flagpoles",
//     "American Flags",
//   ];

//   let index = 0; // Tracks which word is being typed
//   let charIndex = 0; // Tracks character position
//   let isDeleting = false; // Typing forward or deleting backward
//   let speed = 50; // Typing speed

//   function typeEffect() {
//     let currentText = placeholders[index];
//     let displayText = currentText.substring(0, charIndex);
//    if (searchLabel) {
//   searchLabel.textContent = displayText; // Update label text safely
// }


//     if (!isDeleting) {
//       charIndex++;
//       if (charIndex > currentText.length) {
//         isDeleting = true;
//         speed = 200; // Pause before deleting
//       }
//     } else {
//       charIndex--;
//       speed = 150; // Speed up deleting
//       if (charIndex === 0) {
//         isDeleting = false;
//         index = (index + 1) % placeholders.length; // Move to next word
//         speed = 100; // Pause before typing new word
//       }
//     }

//     setTimeout(typeEffect, speed);
//   }

//   typeEffect(); // Start animation

// }


// document.addEventListener("DOMContentLoaded", function () {
//    collection_search();

// });

// // CART TRIGGER ON QUICK ADD BUTTON

// $(document).on("click", ".quick-buy-btn", function () {
//   var $button = $(this);
//   var productid = $(this).data("id");
//   var product_qty = $(this).data("product-qty");
//   $button.find(".loading__spinner").removeClass("hidden");
//   $button.find(".quick_buy").addClass("no_visibility");
//   if (productid) {
//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: {
//         id: productid,
//         quantity: product_qty,
//       },
//       dataType: "json",
//       success: function (response) {
//         console.log("Product added to cart:", response);
//         $(".drawer__inner").load("/cart .drawer__inner > *", function () {
//           $(".drawer").addClass("active");
//           $(".drawer").removeClass("is-empty");
//           $(".cart-count-bubble").load(location.href + " .cart-count-bubble");
//           $button.find(".loading__spinner").addClass("hidden");
//           $button.find(".quick_buy").removeClass("no_visibility");
//           window.initializeCartAddOnSwiper();
//         });
//           // window.location.href = "/cart";
//       },
//       error: function (xhr, status, error) {
//         console.error("Error adding product to cart:", xhr.responseText);
//         $button.find(".loading__spinner").addClass("hidden");
//         $button.find(".quick_buy").removeClass("no_visibility");
//         try {
//         const response = JSON.parse(xhr.responseText);
//         if (response && response.message) {
//           showATCErrorPopup(response.message);
//           $button.find(".quick_buy").removeClass("no_visibility");
//         }
//       } catch (e) {
//         showATCErrorPopup("Something went wrong. Please try again.");
//          $button.find(".quick_buy").removeClass("no_visibility");
//       }
//       },
//     });
//   } else {
//     console.log("Product ID not found.");
//     $button.find(".loading__spinner").addClass("hidden");
//     $button.find(".quick_buy").removeClass("no_visibility");
//   }
// });

// /* Cart Drawer issue when quantity is out of stock */

// function refreshCartDrawer() {
//   $(".drawer__inner").load("/cart .drawer__inner > *", function () {
//     $(".drawer").addClass("active");
//     $(".drawer").removeClass("is-empty");
//   });
// }

// // Observe changes in the error message container
// const errorObserver = new MutationObserver(function (mutations) {
//   mutations.forEach(function (mutation) {
//     if ($(".product-form__error-message").text().trim().length > 0) {
//       refreshCartDrawer();
//     }
//   });
// });

// // Start observing the error message div for changes
// const errorMessageElement = document.querySelector(
//   ".product-form__error-message"
// );
// if (errorMessageElement) {
//   errorObserver.observe(errorMessageElement, {
//     childList: true,
//     subtree: true,
//   });
// }

// /* Cart Drawer issue when quantity is out of stock */

// $(document).on("click", "#predictive_atc", function () {
//   var $button = $(this);
//   var productid = $(this).data("id");
//   var product_qty = $(this).data("product-qty");
//   $button.find(".loading__spinner").removeClass("hidden");
//   $button.find(".text-button").addClass("no_visibility");
  
//   if (productid) {
//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: {
//         id: productid,
//         quantity: product_qty,
//       },
//       dataType: "json",
//       success: function (response) {
//         console.log("Product added to cart:", response);
//         $(".drawer__inner").load("/cart .drawer__inner > *", function () {
//           $(".drawer").addClass("active");
//           $(".drawer").removeClass("is-empty");
//           $(".cart-count-bubble").load(location.href + " .cart-count-bubble");
//            $button.find(".loading__spinner").addClass("hidden");
//            $button.find(".text-button").removeClass("no_visibility");
//           window.initializeCartAddOnSwiper();
//         });
//         //  window.location.href = "/cart";
//       },
//       error: function (xhr, status, error) {
//         console.error("Error adding product to cart:", xhr.responseText);
//          $button.find(".loading__spinner").addClass("hidden");
//          $button.find(".text-button").removeClass("no_visibility");
//          try {
//         const response = JSON.parse(xhr.responseText);
//         if (response && response.message) {
//           showATCErrorPopup(response.message);
//           $button.find(".text-button").removeClass("no_visibility");
//         }
//       } catch (e) {
//         showATCErrorPopup("Something went wrong. Please try again.");
//       }
//       },
//     });
//   } else {
//     console.log("Product ID not found.");
//      $button.find(".loading__spinner").addClass("hidden");
//       $button.find(".text-button").removeClass("no_visibility");
//   }
// });

// // Show error popup
// function showATCErrorPopup(message) {
//   const $popup = $('.custom-atc-error-popup');
//   $popup.find('.popup-message').text(message);
//   $popup.css('display', 'block');

//   setTimeout(() => {
//     $popup.fadeOut(300);
//   }, 3000);
// }




// $(document).on("click", ".predictive_add_to_cart", function () {
//   var $button = $(this);
//   var productid = $(this).data("id");
//   var product_qty = $(this).data("product-qty");
//   $button.find(".loading__spinner").removeClass("hidden");
//   $button.find(".text-button").addClass("no_visibility");
  
//   if (productid) {
//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: {
//         id: productid,
//         quantity: product_qty,
//       },
//       dataType: "json",
//        success: function (response) {
//   console.log("Product added to cart:", response);
//   $(".drawer__inner").load("/cart .drawer__inner > *", function () {
//     $(".drawer").addClass("active");
//     $(".drawer").removeClass("is-empty");

//     $.get("/cart", function(data) {
//       var newCount = $(data).find(".cart-count-bubble").html();
//       $(".cart-count-bubble").html(newCount); 
//     });

//     $button.find(".loading__spinner").addClass("hidden");
//     $button.find(".text-button").removeClass("no_visibility");
//     window.initializeCartAddOnSwiper();
//   });
// },
//       // success: function (response) {
//       //   console.log("Product added to cart:", response);
//       //   $(".drawer__inner").load("/cart .drawer__inner > *", function () {
//       //     $(".drawer").addClass("active");
//       //     $(".drawer").removeClass("is-empty");
//       //     $(".cart-count-bubble").load(location.href + " .cart-count-bubble");
//       //      $button.find(".loading__spinner").addClass("hidden");
//       //      $button.find(".text-button").removeClass("no_visibility");
//       //     window.initializeCartAddOnSwiper();
//       //   });
//       //   //  window.location.href = "/cart";
//       // },
//       error: function (xhr, status, error) {
//         console.error("Error adding product to cart:", xhr.responseText);
//          $button.find(".loading__spinner").addClass("hidden");
//          $button.find(".text-button").removeClass("no_visibility");
//          try {
//         const response = JSON.parse(xhr.responseText);
//         if (response && response.message) {
//           showATCErrorPopup(response.message);
//           $button.find(".text-button").removeClass("no_visibility");
//         }
//       } catch (e) {
//         showATCErrorPopup("Something went wrong. Please try again.");
//       }
//       },
//     });
//   } else {
//     console.log("Product ID not found.");
//      $button.find(".loading__spinner").addClass("hidden");
//       $button.find(".text-button").removeClass("no_visibility");
//   }
// });


// // $(document).on("click", ".quick-buy-btn", function () {
// //   var productid = $(this).data("id");
// //   if (productid) {
// //     // Show loading state (optional)
// //     $(this).addClass("loading");
// //     $.ajax({
// //       type: "POST",
// //       url: "/cart/add.js",
// //       data: { id: productid, quantity: 1 },
// //       dataType: "json",
// //       success: function () {
// //         console.log("Product added to cart");
// //         // Remove loading state
// //         $(".quick-buy-btn").removeClass("loading");
// //         // Open and update the cart drawer
// //         openCartDrawer();
// //       },
// //       error: function (xhr) {
// //         console.error("Error adding product to cart:", xhr.responseText);
// //         $(".quick-buy-btn").removeClass("loading");
// //       },
// //     });
// //   } else {
// //     console.log("Product ID not found.");
// //   }
// // });
// // Function to open cart drawer and update its content
// // function openCartDrawer() {
// //   $.getJSON("/cart.js", function (cart) {
// //     $(document).trigger("cart:updated", cart);
// //     // Open the cart drawer
// //     $(".drawer").addClass("active");
// //     // Delay before loading the updated cart content
// //     setTimeout(function () {
// //       $(".drawer__inner").load("/cart #cart-drawer-content");
// //     }, 500);
// //   });
// // }
// // // Function to update the cart drawer and refresh its content
// // function updateCartDrawer() {
// //   $.getJSON("/cart.js", function (cart) {
// //     $(document).trigger("cart:updated", cart);
// //     $(".drawer").addClass("active");
// //     $.ajax({
// //       url: "/cart",
// //       success: function (data) {
// //         var newContent = $(data).find("#cart-drawer-content").html();
// //         $(".drawer__inner").html(newContent);
// //         console.log("Cart updated successfully!");
// //       },
// //     });
// //   });
// // }

// // PRODUCT ACCORDION

// document.addEventListener("DOMContentLoaded", function () {
//   // Select all accordion titles
//   document
//     .querySelectorAll(".footer-accordion .accordion-title")
//     .forEach((title) => {
//       title.addEventListener("click", function () {
//         // Toggle active class on the clicked title
//         this.classList.toggle("active");

//         // Select the next sibling (ul list)
//         let content = this.nextElementSibling;
//         if (content && content.classList.contains("accordion-content")) {
//           if (content.style.maxHeight) {
//             content.style.maxHeight = null; // Collapse
//           } else {
//             content.style.maxHeight = content.scrollHeight + "px"; // Expand
//           }
//         }
//       });
//     });
// });

// $(document).on("click", ".empty_cart", function () {
//   $(".delete_cart_message").css("display", "block");
//   $(".cancel_cart").css("display", "block");
//   $(".empty_cart_success").css("display", "block");
//   $(".empty_cart").css("display", "none");
// });

// $(document).on("click", ".cancel_cart", function () {
//   $(".delete_cart_message").css("display", "none");
//   $(".cancel_cart").css("display", "none");
//   $(".empty_cart_success").css("display", "none");
//   $(".empty_cart").css("display", "block");
// });

// $(document).ready(function () {
//   // Show popup when trigger button is clicked
//   $(document).on("click", ".empty_cart_trigger", function () {
//     $(".empty_cart_popup, .popup_overlay").fadeIn();
//   });

//   // Hide popup when cancel button is clicked
//   $(document).on("click", ".empty_cart_cancel", function () {
//     $(".empty_cart_popup, .popup_overlay").fadeOut();
//   });

//   $(document).on("click", ".size_guide_popup", function () {
//     $(".size-popup").fadeIn();
//   });

//   $(document).on("click", ".popup-close", function () {
//     $(".size-popup").fadeOut();
//   });

//   $(document).on("click", ".empty_cart_success", function () {
//     setTimeout(function () {
//       $.ajax({
//         type: "POST",
//         url: "/cart/clear.js",
//         success: function () {
//           $(".empty_cart_popup, .popup_overlay").fadeOut();
//           location.reload();
//         },
//         error: function (error) {
//           console.error("Error clearing the cart:", error);
//         },
//       });
//     }, 8000); // 8-second delay
//   });
// });

// document.querySelector(".close_popup").addEventListener("click", function () {
//   document.querySelector(".empty_cart_popup").style.display = "none";
//   document.querySelector(".popup_overlay").style.display = "none";
// });

// /* Cart Coupon */

// $(document).ready(function () {
//   function getAppliedCoupons() {
//     var currentUrl = new URL(window.location.href);
//     var existingCodes = currentUrl.searchParams.get("discount");
//     return existingCodes ? existingCodes.split(",") : [];
//   }

//   function updateCouponDisplay() {
//     var coupons = getAppliedCoupons();
//     var couponList = $(".applied-coupons");
//     couponList.empty();

//     if (coupons.length > 0) {
//       coupons.forEach(function (code) {
//         couponList.append(
//           `<li>${code} <a href="javascript:void(0)" class="remove_coupon" data-code="${code}">✖</a></li>`
//         );
//       });
//       $(".coupon-container").show();
//     } else {
//       $(".coupon-container").hide();
//     }
//   }

//   $(document).on("click", ".add_coupon", function () {
//     $(".cancel_coupon").show();
//     $(".cart-form.coupon-code").show();
//     $(".add_coupon").hide();
//   });

//   $(document).on("click", ".cancel_coupon", function () {
//     $(".cancel_coupon").hide();
//     $(".cart-form.coupon-code").hide();
//     $(".add_coupon").show();
//   });

//   $(document).on("click", ".apply_coupon", function () {
//     var couponCode = $("#coupon_code").val().trim();
//     if (couponCode === "") {
//       alert("Please enter a coupon code.");
//       return;
//     }

//     var appliedCoupons = getAppliedCoupons();
//     if (appliedCoupons.includes(couponCode)) {
//       alert("This coupon is already applied.");
//       return;
//     }

//     appliedCoupons.push(couponCode);
//     window.location.href =
//       "/checkout?discount=" + encodeURIComponent(appliedCoupons.join(","));
//   });

//   $(document).on("click", ".remove_coupon", function () {
//     var removeCode = $(this).data("code");
//     var appliedCoupons = getAppliedCoupons().filter(
//       (code) => code !== removeCode
//     );

//     window.location.href =
//       "/checkout?discount=" + encodeURIComponent(appliedCoupons.join(","));
//   });

//   updateCouponDisplay();
// });

// /* Cart Coupon */

// /* Cart Info */

// $(document).on("click", ".add_info", function () {
//   $(".cancel_info").css("display", "block");
//   $(".zipcode_form").css("display", "block");
//   $(".add_info").css("display", "none");
// });

// $(document).on("click", ".cancel_info", function () {
//   $(".cancel_info").css("display", "none");
//   $(".zipcode_form").css("display", "none");
//   $(".add_info").css("display", "block");
// });

// /* Cart Info */

// $(document).on("click", ".accordion-header_product", function (e) {
//   e.preventDefault(); // Prevent default anchor/button behavior

//   var $header = $(this);
//   var $content = $header.next()[0]; // Get the raw DOM element

//   // Toggle active class
//   $header.toggleClass("active");

//   // Toggle display between 'block' and 'none' like in vanilla JS
//   if ($content.style.display === "block") {
//     $content.style.display = "none";
//   } else {
//     $content.style.display = "block";
//   }
// });



// document.querySelectorAll(".mobile_acc").forEach((button) => {
//   button.addEventListener("click", function () {
//     // Ensure swiper-button-next is enabled
//     setTimeout(() => {
//       const nextButton = document.querySelector(".btn_next");
//       if (nextButton) {
//         nextButton.classList.remove("swiper-button-disabled");
//         nextButton.removeAttribute("disabled"); // Ensures it can be clicked
//       }
//     }, 300); // Small delay to ensure it is applied after DOM updates
//   });
// });



// var swiper = new Swiper(".product_recommend_slider", {
//   slidesPerView: 2,
//   spaceBetween: 24,
//   centeredSlides: false,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     dynamicBullets: true,
//     clickable: true,
//   },
//   breakpoints: {
//     320: {
//       slidesPerView: 2,
//       spaceBetween: 12,
//     },
//     767: {
//       slidesPerView: 3,
//       spaceBetween: 15,
//     },
//     1024: {
//       slidesPerView: 3,
//     },
//     1280: {
//       slidesPerView: 2,
//     },
//     1500: {
//       slidesPerView: 2,
//     },
//   },
//   on: {
//     init() {
//       document
//         .querySelector(".people_bought")
//         .classList.remove("swiper-slider-update");
//     },
//   },
// });


// function initializePeopleAlsoBoughtSwiper() {
//   const swiper = new Swiper(".people_also_bought_data", {
//     slidesPerView: 2,
//     spaceBetween: 20,
//     centeredSlides: false,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     breakpoints: {
//       320: {
//         slidesPerView: 2,
//         spaceBetween: 12,
//       },
//       767: {
//         slidesPerView: 2,
//         spaceBetween: 15,
//       },
//       1024: {
//         slidesPerView: 2,
//       },
//       1280: {
//         slidesPerView: 2,
//       },
//       1500: {
//         slidesPerView: 2,
//       },
//     },
//     on: {
//       // Add Swiper event listeners here if needed
//     },
//   });
// }


// function initializeYouMayAlsoLikeSwiper() {
//   const swiper = new Swiper(".also_like", {
//     slidesPerView: 2,
//     spaceBetween: 20,
//     centeredSlides: false,
//     navigation: {
//       nextEl: ".you_next",
//       prevEl: ".you_prev",
//     },
//     breakpoints: {
//       320: {
//         slidesPerView: 2,
//         spaceBetween: 12,
//       },
//       767: {
//         slidesPerView: 2,
//         spaceBetween: 15,
//       },
//       1024: {
//         slidesPerView: 2,
//       },
//       1280: {
//         slidesPerView: 2,
//       },
//       1500: {
//         slidesPerView: 2,
//       },
//     },
//     on: {
//       // Add Swiper event listeners here if needed
//     },
//   });
// }






// // $(document).on("click", ".check_btn", function () {

// //     var val_data = $(".textbox_input").val();

// //     if(val_data.length > 0){
// //     $(".text_box_error_msg").css("display","none");
// //     }else{
// //     $(".text_box_error_msg").css("display","block");
// //      return false;

// //     }

// // });

// /* Personalization Data */
// $(document).ready(function () {
//   $(document).on("click", ".check_btn", function () {
//     var val_data = $(".textbox_input").val();
//     var isRadioChecked = $(".list_input:checked").length > 0;

//     // Check if text input is required
//     var isTextRequired = $(".textbox_input").attr("required") !== undefined;

//     // Check if radio buttons are required
//     var isRadioRequired = $(".list_input").attr("required") !== undefined;

//     var isValid = true;

//     // Validate text input
//     if (isTextRequired && val_data.trim().length === 0) {
//       $(".text_box_error_msg").css("display", "block");
//       isValid = false;
//     } else {
//       $(".text_box_error_msg").css("display", "none");
//     }

//     // Validate radio button
//     if (isRadioRequired && !isRadioChecked) {
//       $(".list_error_msg").css("display", "block");
//       isValid = false;
//     } else {
//       $(".list_error_msg").css("display", "none");
//     }

//     return isValid; // Prevent form submission if validation fails
//   });

//   // Hide error message when typing in the input field
//   $(document).on("input", ".textbox_input", function () {
//     if ($(this).val().trim().length > 0) {
//       $(".text_box_error_msg").css("display", "none");
//     }
//   });

//   // Hide error message when a radio button is selected
//   $(document).on("change", ".list_input", function () {
//     $(".list_error_msg").css("display", "none");
//   });
// });

// /* Personalization Data cs-add-to-cart */

// $(document).on("click", ".addon-cart", function () {
//   var $button = $(this);
//   $button.find(".add_on_loader").css("display", "flex");
//   var productid = $(this).data("id");
//   var productquantity = $(this).data("product-qty");
//   if (productid) {
//     $.ajax({
//       type: "POST",
//       url: "/cart/add.js",
//       data: {
//         id: productid,
//         quantity: productquantity,
//       },
//       dataType: "json",
//       success: function (response) {
//         console.log("Product added to cart:", response);

//         $(".drawer__inner").load("/cart .drawer__inner > *", function () {
//           $(".drawer").removeClass("is-empty");
//             $.get(location.href, function (data) {
//            var newCount = $(data).find(".cart-count-bubble").html();
//           $(".cart-count-bubble").html(newCount);
//            });
//           // $(".cart-count-bubble").load(location.href + " .cart-count-bubble");
//            $button.find(".add_on_loader").css("display", "none");
//           initializeCartAddOnSwiper();
//         });
//       },
//       error: function (xhr, status, error) {
//         console.error("Error adding product to cart:", xhr.responseText);
//           $button.find(".add_on_loader").css("display", "none");
//       },
//     });
//   } else {
//     console.log("Product ID not found.");
//       $button.find(".add_on_loader").css("display", "none");
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const ul = document.querySelector(".thumbnail-items-scroll-pdp");
//   const upButton = document.querySelector(".arrow-up-slider");
//   const downButton = document.querySelector(".arrow-down-slider");

//   function checkOverflow() {
//     if (ul.scrollHeight > ul.clientHeight) {
//       upButton.style.display = "block";
//       downButton.style.display = "block";
//     } else {
//       upButton.style.display = "none";
//       downButton.style.display = "none";
//     }
//   }

//   function scrollUp() {
//     ul.scrollBy({ top: -100, behavior: "smooth" });
//   }

//   function scrollDown() {
//     ul.scrollBy({ top: 100, behavior: "smooth" });
//   }

//   upButton.addEventListener("click", scrollUp);
//   downButton.addEventListener("click", scrollDown);

//   window.addEventListener("resize", checkOverflow);
//   checkOverflow();
// });

// /* Update product count in mobile on collection page */

// document.addEventListener("DOMContentLoaded", function () {
//   function updateMobileCount() {
//     // Find the updated product count inside ProductGridContainer
//     let updatedCount = document.querySelector(
//       "#ProductGridContainer .custom-top-collection-count"
//     );

//     // Find the mobile version of the product count
//     let mobileCount = document.querySelector(
//       ".mobile_data .custom-top-collection-count"
//     );

//     // If both elements exist, update the mobile count
//     if (updatedCount && mobileCount) {
//       mobileCount.textContent = updatedCount.textContent;
//     }
//   }

//   // Observe changes in ProductGridContainer
//   let observer = new MutationObserver(updateMobileCount);
//   let targetNode = document.getElementById("ProductGridContainer");

//   if (targetNode) {
//     observer.observe(targetNode, { childList: true, subtree: true });
//   }

//   // Run once on page load
//   updateMobileCount();
// });

// /* Update product count in mobile on collection page */

// // Bundled Product Data
// document.addEventListener("DOMContentLoaded", function () {
//   const bundleElements = document.querySelectorAll(".get-data-bundle-comman");
//   if (bundleElements.length > 0) {
//     bundleElements.forEach((element) => {
//       const productOptionGroup = element.getAttribute("data-group-name-bundle");
//       const productHandles = element.textContent.trim().split(",");
//       // Fetch multiple products using the converted array
//       getMultipleProducts(productHandles, productOptionGroup);
//     });
//     updateTotalPrice();
//   }

//   /*document.querySelectorAll(".dropdown-selected").forEach((selectedDiv) => {
//     selectedDiv.addEventListener("click", function () {
//       // Hide all dropdown lists first
//       document.querySelectorAll(".dropdown-list").forEach((dropdown) => {
//         dropdown.style.display = "none";
//       });
//       // Find the related dropdown list and toggle its visibility
//       const relatedDropdown = this.nextElementSibling; // Assuming dropdown-list is the next sibling
//       if (
//         relatedDropdown &&
//         relatedDropdown.classList.contains("dropdown-list")
//       ) {
//         relatedDropdown.style.display = "block";
//       }
//     });
//   });*/

//   document.querySelectorAll(".dropdown-selected").forEach((selectedDiv) => {
//     selectedDiv.addEventListener("click", function () {
//       // Hide all dropdown lists first
//       const optionGroup = this.getAttribute("data-selected_option");
//       document.querySelectorAll(".dropdown-list").forEach((dropdown) => {
//           if (!dropdown.classList.contains(`paste-data-bundle-${optionGroup}`)) {
//               dropdown.style.display = "none";
//           }
//       });
//       // Find the related dropdown list and toggle its visibility
//       const relatedDropdown = this.nextElementSibling; // Assuming dropdown-list is the next sibling
//       if (
//         relatedDropdown &&
//         relatedDropdown.classList.contains("dropdown-list")
//       ) {
//         relatedDropdown.style.display = relatedDropdown.style.display === "block" ? "none" : "block";
//       }
//     });
//   });

//   // Hide dropdowns when clicking outside
//   document.addEventListener("click", function (event) {
//     if (
//       !event.target.closest(".dropdown-selected") &&
//       !event.target.closest(".dropdown-list")
//     ) {
//       document.querySelectorAll(".dropdown-list").forEach((dropdown) => {
//         dropdown.style.display = "none";
//       });
//     }
//   });
// });

// function updateTotalPrice() {
//   const prices = document.getElementsByClassName("selected_price");
//   const values = Array.from(prices).map(
//     (input) => parseFloat(input.value) || 0
//   );
//   const total = values.reduce((sum, value) => sum + value, 0);

//     document.querySelectorAll('.price-item.price-item--regular').forEach((item) => {
//       // Check if this element is inside a parent with the class .price--show-badge
//       if (item.closest('.price--show-badge')) {
//         item.innerText = "$" + total.toFixed(2);
//       }
//     });
// }

// function chooseVariant(variantId, optiongroup) {
//   // Get the selected <li> element using variantId
//   const selectedItem = document.querySelector(`.item-id-${variantId}`);

//   const dropdownLists = document.querySelectorAll(".dropdown-list");
//   dropdownLists.forEach((dropdownList) => {
//     dropdownList.style.display = "none";
//   });

//   if (selectedItem) {
//     // Get the data from the selected item
//     const selectedText = selectedItem.querySelector("span").innerText;
//     const selectedImage = selectedItem.querySelector("img").src;

//     // Get the specific div based on optiongroup and update it
//     const selectedDiv = document.querySelector(
//       `.dropdown-selected.show_selected_${optiongroup}`
//     );
//     if (selectedDiv) {
//       selectedDiv.innerHTML = `
//                 <img src="${selectedImage}" width="40" height="40" style="margin-right: 10px; border-radius: 5px;">
//                 ${selectedText}
//             `;
//     }

//     // Find the hidden input based on the optiongroup and update its value
//     const hiddenInput = document.querySelector(
//       `.attach_selected_id_${optiongroup}`
//     );
//     if (hiddenInput) {
//       hiddenInput.value = variantId;
//     }

//     // Find the hidden price input based on the optiongroup and update its value
//     const hiddenInputPrice = document.querySelector(
//       `.attach_selected_price_${optiongroup}`
//     );
//     if (hiddenInputPrice) {
//       hiddenInputPrice.value = selectedItem.getAttribute("data-price");
//     }

//     updateTotalPrice();
//   }
// }

// /* Working Code
// function getMultipleProducts(handles, optiongroup) {
//   let productList = ""; // Variable to store all <li> elements
//   // Convert handles into an array of fetch requests
//   const fetchPromises = handles.map((handle) =>
//     fetch(`/products/${handle}.json`).then((res) => res.json())
//   );

//   // Execute all fetch requests in parallel
//   Promise.all(fetchPromises)
//     .then((products) => {
//       let firstProductSet = false; // Flag to set the first product in the div
//       // Loop through each product and generate <li> HTML
//       products.forEach((productData) => {
//         if (productData.product) {
//           const product = productData.product;
//           const variant = product.variants[0]; // First variant
//           // Generate <li> element
//           productList += `
//                         <li class="dropdown-item item-id-${variant.id}" 
//                             data-id="${variant.id}"
//                             onclick="chooseVariant(${
//                               variant.id
//                             }, '${optiongroup}')"
//                             data-price="${variant.price}" 
//                             data-handle="${product.handle}" 
//                             data-available="true">
                            
//                             <img src="${
//                               product.image ? product.image.src : ""
//                             }" alt="${product.title}">
//                             <span>
//                                 <span class="bundle--main-title">${
//                                   product.title
//                                 }
//                                     <span class="bundle--price"> | $${
//                                       variant.price
//                                     }</span>
//                                 </span>
//                             </span>
//                         </li>`;

//           // Set first product in the main div
//           if (!firstProductSet) {
//             firstProductSet = true; // Mark flag as set
//             const selectedBaseDiv = document.querySelector(
//               ".dropdown-selected.show_selected_" + optiongroup
//             );
//             if (selectedBaseDiv) {
//               selectedBaseDiv.innerHTML = `
//                                 <img src="${
//                                   product.image ? product.image.src : ""
//                                 }" width="40" height="40" style="margin-right: 10px; border-radius: 5px;">
//                                 <span class="bundle--main-title">
//                                     ${product.title}
//                                     <span class="bundle--price"> | $${
//                                       variant.price
//                                     }</span>
//                                 </span>`;
//             }

//             // Construct the selector dynamically using optiongroup
//             const hiddenVariantInput = document.querySelector(
//               ".attach_selected_id_" + optiongroup
//             );

//             // Check if the hidden input exists before assigning the value
//             if (hiddenVariantInput) {
//               hiddenVariantInput.value = variant.id; // Replace with the actual variant ID
//             }

//             // Construct the selector dynamically using optiongroup
//             const hiddenVariantInputPrice = document.querySelector(
//               ".attach_selected_price_" + optiongroup
//             );

//             // Check if the hidden input exists before assigning the value
//             if (hiddenVariantInputPrice) {
//               hiddenVariantInputPrice.value = variant.price; // Replace with the actual variant ID
//             }
//           }
//         }
//       });

//       //console.log("Final Product List HTML:", productList);

//       // Insert HTML into the correct container
//       const pasteTarget = document.querySelector(
//         ".paste-data-bundle-" + optiongroup
//       );
//       if (pasteTarget) {
//         pasteTarget.innerHTML = productList;
//       }
//     })
//     .catch((error) => console.error("Error fetching products:", error));
// }*/

// /* New Code Start For Default Selection Option */
// function getMultipleProducts(handles, optiongroup) {
//   let productList = "";
//   const prioritizedHandles = [];
//   const regularHandles = [];

//   // Separate handles into prioritized and regular
//   handles.forEach((handle) => {
//     const [cleanHandle, priorityFlag] = handle.split("~");
//     if (priorityFlag === "true") {
//       prioritizedHandles.push({ handle: cleanHandle, original: handle });
//     } else {
//       regularHandles.push({ handle: cleanHandle, original: handle });
//     }
//   });

//   // Rebuild handle array with prioritized first
//   const sortedHandles = prioritizedHandles.concat(regularHandles);

//   const fetchPromises = sortedHandles.map((h) =>
//     fetch(`/products/${h.handle}.json`).then((res) => res.json())
//   );

//   Promise.all(fetchPromises)
//     .then((products) => {
//       let firstProductSet = false;

//       products.forEach((productData, index) => {
//         if (productData.product) {
//           const product = productData.product;
//           const variant = product.variants[0];
//           productList += `
//                         <li class="dropdown-item item-id-${variant.id}" 
//                             data-id="${variant.id}"
//                             onclick="chooseVariant(${variant.id}, '${optiongroup}')"
//                             data-price="${variant.price}" 
//                             data-handle="${product.handle}" 
//                             data-available="true">
                            
//                             <img src="${product.image ? product.image.src : ""}" alt="${product.title}">
//                             <span>
//                                 <span class="bundle--main-title">
//                                     ${product.title}
//                                     <span class="bundle--price"> | $${variant.price}</span>
//                                 </span>
//                             </span>
//                         </li>`;

//           if (!firstProductSet) {
//             firstProductSet = true;
//             const selectedBaseDiv = document.querySelector(".dropdown-selected.show_selected_" + optiongroup);
//             if (selectedBaseDiv) {
//               selectedBaseDiv.innerHTML = `
//                                 <img src="${product.image ? product.image.src : ""}" width="40" height="40" style="margin-right: 10px; border-radius: 5px;">
//                                 <span class="bundle--main-title">
//                                     ${product.title}
//                                     <span class="bundle--price"> | $${variant.price}</span>
//                                 </span>`;
//             }
//             const hiddenVariantInput = document.querySelector(".attach_selected_id_" + optiongroup);
//             if (hiddenVariantInput) hiddenVariantInput.value = variant.id;

//             const hiddenVariantInputPrice = document.querySelector(".attach_selected_price_" + optiongroup);
//             if (hiddenVariantInputPrice) hiddenVariantInputPrice.value = variant.price;
//           }
//         }
//       });

//       const pasteTarget = document.querySelector(".paste-data-bundle-" + optiongroup);
//       if (pasteTarget) {
//         pasteTarget.innerHTML = productList;
//       }
//     })
//     .catch((error) => console.error("Error fetching products:", error));
// }
// /* New Code End For Default Selection Option */

// $(document).ready(function () {
//   $(".rich-text__heading").click(function () {
//     $(".rich-text_collapse").toggleClass("active");
//   });
// });




// /* Grid and List View */

// /*

// $(document).ready(function () {


//   $(document).on('click','.view-selector', function () {

//     // Remove the class from all view selectors
//     $('.view-selector').removeClass('active');

//     // Add the class to the clicked element
//     $(this).addClass('active');
//   });


//   var savedClass = localStorage.getItem('selectedViewClass');

//   if (savedClass) {

//     $('.view-selector').removeClass('active');
//     $('.view-selector.' + savedClass).addClass('active');

//     changeClass('.product-grid-container', savedClass);
//   }

// });

// function changeClass(targetSelector, className) {

//   // Get the target element
//   var $targetElement = $(targetSelector);
//   var $paginateElement = $('.paginate-view');

//   // Remove previously added classes for toggling (optional)
//   $targetElement.removeClass('grid-view list-view');

//   // Add the new selected class
//   $targetElement.addClass(className);

//   // jQuery doesn't have an addAttribute function, you might want to use .attr()
//   // Assuming you want to add the class name as an attribute (not common practice for class toggling)
//   $paginateElement.attr('data-view', className);

//     // Store the selected class in localStorage
//   localStorage.setItem('selectedViewClass', className);
// }

// */

// /* Grid and List View */




// document.addEventListener('DOMContentLoaded', function () {
//   if (window.location.pathname !== '/cart') return; // 🚫 Exit early if not on cart page

//   document.addEventListener('click', function (e) {
//     const quickBuyButton = e.target.closest('.quick-buy-btn');
    
//     if (!quickBuyButton) return;

//     e.preventDefault();
//     e.stopPropagation();

//     const variantId = quickBuyButton.getAttribute('data-id');
//     const quickBuySpan = quickBuyButton.querySelector('.quick_buy');
//     const $button = $(this);
//     $button.find(".loading__spinner").removeClass("hidden");
//     $button.find(".quick_buy").addClass("no_visibility");

//     if (!variantId) {
//       console.error('Variant ID not found.');
//       return;
//     }


//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json',
//       },
//       body: JSON.stringify({
//         items: [{
//           id: variantId,
//           quantity: 1
//         }]
//       })
//     })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error('Failed to add to cart');
//         $button.find(".loading__spinner").addClass("hidden");
//         $button.find(".quick_buy").removeClass("no_visibility");
//         showATCErrorPopup("The maximum quantity of this product is already in your cart.");
//       }
//       return response.json();
//     })
//     .then(() => {
//       window.location.reload(); // Reload cart page to reflect new item
//        $button.find(".loading__spinner").addClass("hidden");
//        $button.find(".quick_buy").removeClass("no_visibility");
//     })
//     .catch(error => {
//       console.error(error);
//       if (quickBuySpan) quickBuySpan.style.display = 'inline';
//       $button.find(".loading__spinner").addClass("hidden");
//       $button.find(".quick_buy").removeClass("no_visibility");
//       showATCErrorPopup("The maximum quantity of this product is already in your cart.");
//     });
//   }, true); // Capture phase to prevent drawer
// });


//  /* Heavy Duty Residential Filters */

//   document.addEventListener("DOMContentLoaded", function () {
//     const currentParams = new URLSearchParams(window.location.search);
//     const currentSize = currentParams.get("filter.p.m.ols.size");

//     document.querySelectorAll(".size-filter-item .view_btn").forEach((btn) => {
//       const btnUrl = new URL(btn.href, window.location.origin);
//       const btnSize = btnUrl.searchParams.get("filter.p.m.ols.size");

//       // Check and update button state on page load
//       if (btnSize === currentSize) {
//         btn.textContent = "Selected";
//         btn.classList.add("selected");
//       } else {
//         btn.textContent = "View";
//         btn.classList.remove("selected");
//       }

//       // Click handler
//       btn.addEventListener("click", function (e) {
//         if (btnSize === currentSize) {
//           e.preventDefault();

//           // Get the base collection URL (remove everything after '?')
//           const baseUrl = window.location.pathname;

//           // Redirect to base collection without any filter
//           window.location.href = baseUrl;
//         }
//       });
//     });
//   });

// /* Heavy Duty Residential Filters */




// function copyDesktopToMobileAccordion() {
//   const desktop = document.querySelector('.product_accordian_content.desktop_accord');
//   const mobile = document.querySelector('.product_accordian_content.mobile_accord');

//   if (desktop && mobile) {
//     mobile.innerHTML = desktop.innerHTML;
//   }
// }

//   document.addEventListener('DOMContentLoaded', function () {
//     copyDesktopToMobileAccordion();
//     initializePeopleAlsoBoughtSwiper();
//     initializeYouMayAlsoLikeSwiper();
//   });


// document.addEventListener("DOMContentLoaded", function () {
//   const overlay = document.querySelector(".new-menu-overlay");
//   if (overlay) {
//     overlay.innerHTML = ""; // This removes &nbsp; or any content inside the div
//   }
// });


// /* Tooltip */

// document.addEventListener('DOMContentLoaded', function () {
//   const wrapper = document.querySelector('.satisfaction_guarantee');
//   if (!wrapper) return; // Exit if not found

//   const icon = wrapper.querySelector('.tooltip-icon');
//   if (!icon) return; // Exit if not found

//   const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

//   if (isTouchDevice) {
//     // Mobile: Toggle on tap
//     ['touchstart', 'click'].forEach(evt => {
//       icon.addEventListener(evt, function (e) {
//         e.preventDefault();
//         e.stopPropagation();

//         // Toggle class directly
//         wrapper.classList.toggle('show-tooltip');
//       });
//     });

//     // Close tooltip when tapping outside
//     ['touchstart', 'click'].forEach(evt => {
//       document.addEventListener(evt, function (e) {
//         if (!wrapper.contains(e.target)) {
//           wrapper.classList.remove('show-tooltip');
//         }
//       });
//     });
//   } else {
//     // Desktop: Hover
//     wrapper.addEventListener('mouseenter', function () {
//       wrapper.classList.add('show-tooltip');
//     });

//     wrapper.addEventListener('mouseleave', function () {
//       wrapper.classList.remove('show-tooltip');
//     });
//   }
// });

// /* Tooltip */


// /* Best Seller */

//   window.initializeBestSellerswiper = function () {
//   var swiper = new Swiper('.best_seller_swiper', {
//       slidesPerView: 1.5,
//       spaceBetween: 20,
//       navigation: {
//         nextEl: '.best_next',
//         prevEl: '.best_prev',
//       },
//       breakpoints: {
//         640: {
//           slidesPerView: 2
//         },
//         768: {
//           slidesPerView: "auto"
//         },
//         1024: {
//           slidesPerView: "auto"
//           // slidesPerView: 4
//         }
//       }
//     });


// };

// // Call the function when the page loads
// document.addEventListener("DOMContentLoaded", function () {
//   window.initializeBestSellerswiper();
// });

// /* Best Seller */


// /* Predictive Search */

// document.addEventListener("DOMContentLoaded", function () {
//   const searchInput = document.getElementById("searchInput");
//   const searchButton = document.querySelector(".search__button_predictive");
//   const errorMessage = document.querySelector(".form_submit_error");
//   const predictiveSearch = document.querySelector("predictive-search");
//   const form = searchInput.closest("form");

//   let inactivityTimer;

//   // Function to clear error and class
//   function clearError() {
//     predictiveSearch?.classList.remove("empty-search");
//     if (errorMessage) errorMessage.style.display = "none";
//   }

//   // Start or reset 5-second timer
//   function startInactivityTimer() {
//     clearTimeout(inactivityTimer);
//     inactivityTimer = setTimeout(clearError, 5000); // 5 seconds
//   }

//   // Hide error initially
//   if (errorMessage) {
//     errorMessage.style.display = "none";
//   }

//   // Show error if input is empty on search button click
//   searchButton?.addEventListener("click", function (e) {
//     const searchValue = searchInput.value.trim();

//     if (searchValue === "") {
//       e.preventDefault();

//       predictiveSearch?.classList.add("empty-search");
//       if (predictiveSearch?.classList.contains("empty-search")) {
//         errorMessage && (errorMessage.style.display = "flex");
//       }

//       startInactivityTimer();
//     } else {
//       clearError();
//     }
//   });

//   // Prevent predictive search from activating on empty input
//   searchInput?.addEventListener("input", function (e) {
//     const value = searchInput.value.trim();

//     if (value === "") {
//       // Prevent predictive search from triggering
//       e.stopImmediatePropagation();

//       predictiveSearch?.classList.add("empty-search");
//       errorMessage && (errorMessage.style.display = "flex");

//      // startInactivityTimer();
//       clearError();
//     } else {
//       clearError();
//     }
//   });

//   // Prevent form submission via Enter key if input is empty
//   searchInput?.addEventListener("keydown", function (e) {
//     if (e.key === "Enter" && searchInput.value.trim() === "") {
//       e.preventDefault();
//     }
//   });

//   // Prevent form submission entirely if input is empty
//   form?.addEventListener("submit", function (e) {
//     if (searchInput.value.trim() === "") {
//       e.preventDefault();

//       predictiveSearch?.classList.add("empty-search");
//       errorMessage && (errorMessage.style.display = "flex");

//       startInactivityTimer();
//     }
//   });

//   // Remove error and class if user clicks outside the search area
//   document.addEventListener("click", function (event) {
//     const isClickInside =
//       predictiveSearch?.contains(event.target) ||
//       searchInput?.contains(event.target);

//     if (!isClickInside) {
//       clearError();
//     }
//   });
// });

// /* Search Auto Suggestion */

// document.addEventListener("DOMContentLoaded", function () {
//   const input = document.querySelector('.search__input.field__input');
//   const predictiveSearch = document.querySelector('predictive-search');
//   const placeholder = document.querySelector('.placeholder-text');

//   if (!input || !predictiveSearch || !placeholder) return;

//   let currentIndex = -1;
//   let lastTyped = "";

//   input.addEventListener('input', () => {
//     currentIndex = -1;
//     lastTyped = input.value;

//     // Hide placeholder when user types
//     placeholder.style.display = lastTyped.trim() !== "" ? "none" : "block";
//   });

//   input.addEventListener('keydown', function (e) {
//     // Get all valid suggestions only (excluding placeholder/labels etc.)
//     const suggestions = Array.from(
//       predictiveSearch.querySelectorAll('[role="option"]')
//     ).filter(el => {
//       const labelEl = el.querySelector('.predictive-search__item-heading, .predictive-search__item, a, span');
//       if (!labelEl) return false;
//       const text = labelEl.textContent.trim().toLowerCase();
//       // Filter out things like "Search for" or empty/irrelevant
//       return text && !text.startsWith("search for");
//     });

//     if (suggestions.length === 0) return;

//     if (["ArrowDown", "ArrowRight"].includes(e.key)) {
//       e.preventDefault();
//       currentIndex = (currentIndex + 1) % suggestions.length;
//       fillWithSuggestion(suggestions, currentIndex);
//     } else if (["ArrowUp", "ArrowLeft"].includes(e.key)) {
//       e.preventDefault();
//       currentIndex = (currentIndex <= 0) ? suggestions.length - 1 : currentIndex - 1;
//       fillWithSuggestion(suggestions, currentIndex);
//     }
//   });

//   function fillWithSuggestion(suggestions, index) {
//     suggestions.forEach(el => el.setAttribute("aria-selected", "false"));
//     const selected = suggestions[index];
//     selected.setAttribute("aria-selected", "true");

//     const labelEl = selected.querySelector('.predictive-search__item-heading, .predictive-search__item, a, span');
//     if (!labelEl) return;

//     const suggestionText = labelEl.textContent.trim();

//     // Hide placeholder if suggestion is used
//     placeholder.style.display = "none";

//     // Only autocomplete if it starts with last typed string
//     if (suggestionText.toLowerCase().startsWith(lastTyped.toLowerCase())) {
//       input.value = suggestionText;
//       input.setSelectionRange(lastTyped.length, suggestionText.length);
//     } else {
//       input.value = suggestionText;
//       input.setSelectionRange(0, suggestionText.length);
//     }
//   }
// });

// /* Search Auto Suggestion */


// /* Predictive Search */


// /* Expandable Content */

// $(document).ready(function(){
//   $('.more-button').click(function() {
//     $(".expandable_content").css("display", "block");
//     $(".more-button").css("display", "none");
//     $(".less-button").css("display", "block");
//   });

//   $('.less-button').click(function() {
//     $(".expandable_content").css("display", "none");
//     $(".more-button").css("display", "block");
//     $(".less-button").css("display", "none");

//     // Scroll only on mobile devices (width <= 768px)
//     if (window.innerWidth <= 768) {
//       document.getElementById('expand_section').scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//     }
//   });
// });

// /* Expandable Content */


// /* Play Icon video play */

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".thumbnail__badge.video_play").forEach(function (badge) {
//     badge.addEventListener("click", function (e) {
//       e.preventDefault(); // stop accidental blocking
//       const button = badge.closest("li").querySelector("button.thumbnail");
//       if (button) {
//         button.click(); // trigger same behavior as clicking thumbnail

//         // Hide the play icon inside the active button
//         if (button.getAttribute("aria-current") === "true") {
//           badge.style.display = "none";
//         }
//         else{
//           badge.style.display = "block";
//         }
//       }
//     });
//   });
// });

// /* Play Icon video play */


// /* Buy Now */


// $(document).on("click", ".quick-buy-now", function () {
//   var $button = $(this);
//   var productId = $button.data("id");   // variant ID
//   var productQty = $button.data("product-qty") || 1;

//   if (!productId) {
//     console.log("Variant ID not found.");
//     return;
//   }

//   // Instantly show loader
//   $button.find(".loading__spinner").removeClass("hidden");
//   $button.find(".quick_buy").addClass("no_visibility");

//   // Add product to cart via Ajax
//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: {
//       id: productId,
//       quantity: productQty
//     },
//     dataType: "json",
//     success: function () {
//       // Hide loader + show text again
//       $button.find(".loading__spinner").addClass("hidden");
//       $button.find(".quick_buy").removeClass("no_visibility");

//       // Redirect to checkout
//       window.location.href = "/checkout";
//     },
//     error: function (xhr) {
//       console.error("Quick buy failed", xhr);

//       // Reset loader if error
//       $button.find(".loading__spinner").addClass("hidden");
//       $button.find(".quick_buy").removeClass("no_visibility");
//     }
//   });
// });


// // Attach listeners (use native events to be robust)
// window.addEventListener('pageshow', checkAndClearLoader);
// document.addEventListener('visibilitychange', function () {
//   if (document.visibilityState === 'visible') {
//     // small delay to allow browser to fully restore DOM
//     setTimeout(function () { checkAndClearLoader(); }, 50);
//   }
// });
// window.addEventListener('load', function () { checkAndClearLoader(); });




// /* Buy Now */

(function () {
  "use strict";

  const SWIPER_INSTANCES = {};

  function destroySwiperInstance(key) {
    if (SWIPER_INSTANCES[key] && typeof SWIPER_INSTANCES[key].destroy === "function") {
      SWIPER_INSTANCES[key].destroy(true, true);
      SWIPER_INSTANCES[key] = null;
    }
  }

  function initOrReinitSwiper(key, elementOrSelector, config) {
    const el =
      typeof elementOrSelector === "string"
        ? document.querySelector(elementOrSelector)
        : elementOrSelector;

    if (!el) {
      destroySwiperInstance(key);
      return null;
    }

    destroySwiperInstance(key);
    SWIPER_INSTANCES[key] = new Swiper(el, config);
    return SWIPER_INSTANCES[key];
  }

  function safeAddEvent(selector, eventName, handler) {
    const el = document.querySelector(selector);
    if (el) el.addEventListener(eventName, handler);
  }

  function parseHTML(htmlText) {
    return new DOMParser().parseFromString(htmlText, "text/html");
  }

  function fetchText(url) {
    return fetch(url, {
      method: "GET",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    }).then((res) => res.text());
  }

  function updateCartCountFromHTML(htmlText) {
    const doc = parseHTML(htmlText);
    const newBubble = doc.querySelector(".cart-count-bubble");
    const currentBubble = document.querySelector(".cart-count-bubble");

    if (newBubble && currentBubble) {
      currentBubble.innerHTML = newBubble.innerHTML;
    }
  }

  function refreshCartCount() {
    return fetchText("/cart")
      .then(updateCartCountFromHTML)
      .catch((error) => console.error("Error refreshing cart count:", error));
  }

  function refreshCartDrawer(callback) {
    $(".drawer__inner").load("/cart .drawer__inner > *", function () {
      $(".drawer").addClass("active").removeClass("is-empty");
      refreshCartCount().finally(function () {
        window.initializeCartAddOnSwiper();
        if (typeof callback === "function") callback();
      });
    });
  }

  function showATCErrorPopup(message) {
    const $popup = $(".custom-atc-error-popup");
    if (!$popup.length) return;

    $popup.find(".popup-message").text(message);
    $popup.css("display", "block");

    setTimeout(() => {
      $popup.fadeOut(300);
    }, 3000);
  }

  window.showATCErrorPopup = showATCErrorPopup;
  window.refreshCartDrawer = refreshCartDrawer;

  function setButtonLoading($button, loadingSelector, textSelector, isLoading) {
    if (!$button || !$button.length) return;

    if (loadingSelector) {
      if (isLoading) $button.find(loadingSelector).removeClass("hidden");
      else $button.find(loadingSelector).addClass("hidden");
    }

    if (textSelector) {
      if (isLoading) $button.find(textSelector).addClass("no_visibility");
      else $button.find(textSelector).removeClass("no_visibility");
    }
  }

  function setAddonLoading($button, loaderSelector, isLoading) {
    if (!$button || !$button.length || !loaderSelector) return;
    $button.find(loaderSelector).css("display", isLoading ? "flex" : "none");
  }

  function extractErrorMessage(xhr, fallback) {
    try {
      const response = JSON.parse(xhr.responseText);
      return response && response.message ? response.message : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function addToCartAjax(options) {
    const {
      productId,
      quantity,
      $button,
      loadingSelector,
      textSelector,
      addonLoaderSelector,
      onSuccess,
      onError,
    } = options;

    if (!productId) {
      console.log("Product ID not found.");
      if (addonLoaderSelector) setAddonLoading($button, addonLoaderSelector, false);
      else setButtonLoading($button, loadingSelector, textSelector, false);
      return;
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: productId,
        quantity: quantity || 1,
      },
      dataType: "json",
      success: function (response) {
        console.log("Product added to cart:", response);

        refreshCartDrawer(function () {
          if (addonLoaderSelector) setAddonLoading($button, addonLoaderSelector, false);
          else setButtonLoading($button, loadingSelector, textSelector, false);

          if (typeof onSuccess === "function") onSuccess(response);
        });
      },
      error: function (xhr, status, error) {
        console.error("Error adding product to cart:", xhr.responseText || error);

        if (addonLoaderSelector) setAddonLoading($button, addonLoaderSelector, false);
        else setButtonLoading($button, loadingSelector, textSelector, false);

        if (typeof onError === "function") {
          onError(xhr, status, error);
        } else {
          showATCErrorPopup(extractErrorMessage(xhr, "Something went wrong. Please try again."));
        }
      },
    });
  }

  function startTypeEffect(targetId, placeholders) {
    const target = document.getElementById(targetId);
    if (!target) return;

    let index = 0;
    let charIndex = 0;
    let isDeleting = false;
    let speed = 50;

    function typeEffect() {
      const currentText = placeholders[index];
      target.textContent = currentText.substring(0, charIndex);

      if (!isDeleting) {
        charIndex++;
        if (charIndex > currentText.length) {
          isDeleting = true;
          speed = 200;
        }
      } else {
        charIndex--;
        speed = 150;
        if (charIndex === 0) {
          isDeleting = false;
          index = (index + 1) % placeholders.length;
          speed = 100;
        }
      }

      setTimeout(typeEffect, speed);
    }

    typeEffect();
  }

  window.collection_search = function () {
    startTypeEffect("collection_searchLabel", [
      "Commercial Flags",
      "Stick Flags",
      "Residential Flagpoles",
      "American Flags",
    ]);
  };

  function cloneRelatedProducts() {
    const peopleAlsoBought = document.querySelector(".related-products");
    const desktopContainer = document.querySelector(".you-may-also");
    const mobileContainer = document.querySelector(".you-may-also-mobile");

    if (!peopleAlsoBought) return;

    if (desktopContainer && !desktopContainer.querySelector(".related-products")) {
      desktopContainer.appendChild(peopleAlsoBought.cloneNode(true));
    }

    if (mobileContainer && !mobileContainer.querySelector(".related-products")) {
      mobileContainer.appendChild(peopleAlsoBought.cloneNode(true));
    }
  }

  function initFooterAccordion() {
    document.querySelectorAll(".footer-accordion .accordion-title").forEach((title) => {
      title.addEventListener("click", function () {
        this.classList.toggle("active");
        const content = this.nextElementSibling;
        if (content && content.classList.contains("accordion-content")) {
          content.style.maxHeight = content.style.maxHeight ? null : content.scrollHeight + "px";
        }
      });
    });
  }

  function initMobileAccButtons() {
    document.querySelectorAll(".mobile_acc").forEach((button) => {
      button.addEventListener("click", function () {
        setTimeout(() => {
          const nextButton = document.querySelector(".btn_next");
          if (nextButton) {
            nextButton.classList.remove("swiper-button-disabled");
            nextButton.removeAttribute("disabled");
          }
        }, 300);
      });
    });
  }

  function initializeProductRecommendSwiper() {
    initOrReinitSwiper("productRecommend", ".product_recommend_slider", {
      slidesPerView: 2,
      spaceBetween: 24,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        clickable: true,
      },
      breakpoints: {
        320: { slidesPerView: 2, spaceBetween: 12 },
        767: { slidesPerView: 3, spaceBetween: 15 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 2 },
        1500: { slidesPerView: 2 },
      },
      on: {
        init() {
          const peopleBought = document.querySelector(".people_bought");
          if (peopleBought) peopleBought.classList.remove("swiper-slider-update");
        },
      },
    });
  }

  function initializePeopleAlsoBoughtSwiper() {
    initOrReinitSwiper("peopleAlsoBought", ".people_also_bought_data", {
      slidesPerView: 2,
      spaceBetween: 20,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: { slidesPerView: 2, spaceBetween: 12 },
        767: { slidesPerView: 2, spaceBetween: 15 },
        1024: { slidesPerView: 2 },
        1280: { slidesPerView: 2 },
        1500: { slidesPerView: 2 },
      },
    });
  }

  function initializeYouMayAlsoLikeSwiper() {
    initOrReinitSwiper("youMayAlsoLike", ".also_like", {
      slidesPerView: 2,
      spaceBetween: 20,
      centeredSlides: false,
      navigation: {
        nextEl: ".you_next",
        prevEl: ".you_prev",
      },
      breakpoints: {
        320: { slidesPerView: 2, spaceBetween: 12 },
        767: { slidesPerView: 2, spaceBetween: 15 },
        1024: { slidesPerView: 2 },
        1280: { slidesPerView: 2 },
        1500: { slidesPerView: 2 },
      },
    });
  }

  window.initializeBestSellerswiper = function () {
    initOrReinitSwiper("bestSeller", ".best_seller_swiper", {
      slidesPerView: 1.5,
      spaceBetween: 20,
      navigation: {
        nextEl: ".best_next",
        prevEl: ".best_prev",
      },
      breakpoints: {
        640: { slidesPerView: 2 },
        768: { slidesPerView: "auto" },
        1024: { slidesPerView: "auto" },
      },
    });
  };

  window.initializeCartAddOnSwiper = function () {
    const addOnSection = document.querySelector(".add_on_section");
    const slider = document.querySelector(".add-on-item");

    if (addOnSection && addOnSection.children.length === 0) {
      destroySwiperInstance("cartAddOn");
      addOnSection.remove();
      return;
    }

    if (!slider) {
      destroySwiperInstance("cartAddOn");
      return;
    }

    initOrReinitSwiper("cartAddOn", slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
      navigation: {
        nextEl: ".next",
        prevEl: ".prev",
      },
      breakpoints: {
        320: { slidesPerView: 1 },
        1500: { slidesPerView: 1.5 },
      },
    });
  };

  $(document).on("click", ".quick-buy-btn", function () {
    const $button = $(this);
    const productId = $button.data("id");
    const productQty = $button.data("product-qty");

    setButtonLoading($button, ".loading__spinner", ".quick_buy", true);

    addToCartAjax({
      productId,
      quantity: productQty,
      $button,
      loadingSelector: ".loading__spinner",
      textSelector: ".quick_buy",
      onError: function (xhr) {
        setButtonLoading($button, ".loading__spinner", ".quick_buy", false);
        showATCErrorPopup(extractErrorMessage(xhr, "Something went wrong. Please try again."));
      },
    });
  });

  $(document).on("click", "#predictive_atc", function () {
    const $button = $(this);
    const productId = $button.data("id");
    const productQty = $button.data("product-qty");

    setButtonLoading($button, ".loading__spinner", ".text-button", true);

    addToCartAjax({
      productId,
      quantity: productQty,
      $button,
      loadingSelector: ".loading__spinner",
      textSelector: ".text-button",
      onError: function (xhr) {
        setButtonLoading($button, ".loading__spinner", ".text-button", false);
        showATCErrorPopup(extractErrorMessage(xhr, "Something went wrong. Please try again."));
      },
    });
  });

  $(document).on("click", ".predictive_add_to_cart", function () {
    const $button = $(this);
    const productId = $button.data("id");
    const productQty = $button.data("product-qty");

    setButtonLoading($button, ".loading__spinner", ".text-button", true);

    addToCartAjax({
      productId,
      quantity: productQty,
      $button,
      loadingSelector: ".loading__spinner",
      textSelector: ".text-button",
      onError: function (xhr) {
        setButtonLoading($button, ".loading__spinner", ".text-button", false);
        showATCErrorPopup(extractErrorMessage(xhr, "Something went wrong. Please try again."));
      },
    });
  });

  $(document).on("click", ".addon-cart", function () {
    const $button = $(this);
    const productId = $button.data("id");
    const productQty = $button.data("product-qty");

    setAddonLoading($button, ".add_on_loader", true);

    addToCartAjax({
      productId,
      quantity: productQty,
      $button,
      addonLoaderSelector: ".add_on_loader",
      onError: function () {
        setAddonLoading($button, ".add_on_loader", false);
      },
    });
  });

  const errorMessageElement = document.querySelector(".product-form__error-message");
  if (errorMessageElement) {
    const errorObserver = new MutationObserver(function () {
      if ($(".product-form__error-message").text().trim().length > 0) {
        refreshCartDrawer();
      }
    });

    errorObserver.observe(errorMessageElement, {
      childList: true,
      subtree: true,
    });
  }

  $(document).on("click", ".empty_cart", function () {
    $(".delete_cart_message, .cancel_cart, .empty_cart_success").css("display", "block");
    $(".empty_cart").css("display", "none");
  });

  $(document).on("click", ".cancel_cart", function () {
    $(".delete_cart_message, .cancel_cart, .empty_cart_success").css("display", "none");
    $(".empty_cart").css("display", "block");
  });

  $(document).on("click", ".empty_cart_trigger", function () {
    $(".empty_cart_popup, .popup_overlay").fadeIn();
  });

  $(document).on("click", ".empty_cart_cancel", function () {
    $(".empty_cart_popup, .popup_overlay").fadeOut();
  });

  $(document).on("click", ".size_guide_popup", function () {
    $(".size-popup").fadeIn();
  });

  $(document).on("click", ".popup-close", function () {
    $(".size-popup").fadeOut();
  });

  $(document).on("click", ".empty_cart_success", function () {
    setTimeout(function () {
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        success: function () {
          $(".empty_cart_popup, .popup_overlay").fadeOut();
          location.reload();
        },
        error: function (error) {
          console.error("Error clearing the cart:", error);
        },
      });
    }, 8000);
  });

  safeAddEvent(".close_popup", "click", function () {
    const popup = document.querySelector(".empty_cart_popup");
    const overlay = document.querySelector(".popup_overlay");
    if (popup) popup.style.display = "none";
    if (overlay) overlay.style.display = "none";
  });

  $(document).on("click", ".add_info", function () {
    $(".cancel_info, .zipcode_form").css("display", "block");
    $(".add_info").css("display", "none");
  });

  $(document).on("click", ".cancel_info", function () {
    $(".cancel_info, .zipcode_form").css("display", "none");
    $(".add_info").css("display", "block");
  });

  $(document).on("click", ".accordion-header_product", function (e) {
    e.preventDefault();

    const $header = $(this);
    const $content = $header.next()[0];
    $header.toggleClass("active");

    if ($content) {
      $content.style.display = $content.style.display === "block" ? "none" : "block";
    }
  });

  $(document).on("click", ".check_btn", function () {
    const valData = $(".textbox_input").val() || "";
    const isRadioChecked = $(".list_input:checked").length > 0;
    const isTextRequired = $(".textbox_input").attr("required") !== undefined;
    const isRadioRequired = $(".list_input").attr("required") !== undefined;

    let isValid = true;

    if (isTextRequired && valData.trim().length === 0) {
      $(".text_box_error_msg").css("display", "block");
      isValid = false;
    } else {
      $(".text_box_error_msg").css("display", "none");
    }

    if (isRadioRequired && !isRadioChecked) {
      $(".list_error_msg").css("display", "block");
      isValid = false;
    } else {
      $(".list_error_msg").css("display", "none");
    }

    return isValid;
  });

  $(document).on("input", ".textbox_input", function () {
    if ($(this).val().trim().length > 0) {
      $(".text_box_error_msg").css("display", "none");
    }
  });

  $(document).on("change", ".list_input", function () {
    $(".list_error_msg").css("display", "none");
  });

  document.addEventListener("DOMContentLoaded", function () {
    const ul = document.querySelector(".thumbnail-items-scroll-pdp");
    const upButton = document.querySelector(".arrow-up-slider");
    const downButton = document.querySelector(".arrow-down-slider");

    if (!ul || !upButton || !downButton) return;

    function checkOverflow() {
      const hasOverflow = ul.scrollHeight > ul.clientHeight;
      upButton.style.display = hasOverflow ? "block" : "none";
      downButton.style.display = hasOverflow ? "block" : "none";
    }

    function scrollUp() {
      ul.scrollBy({ top: -100, behavior: "smooth" });
    }

    function scrollDown() {
      ul.scrollBy({ top: 100, behavior: "smooth" });
    }

    upButton.addEventListener("click", scrollUp);
    downButton.addEventListener("click", scrollDown);
    window.addEventListener("resize", checkOverflow);
    checkOverflow();
  });

  document.addEventListener("DOMContentLoaded", function () {
    function updateMobileCount() {
      const updatedCount = document.querySelector("#ProductGridContainer .custom-top-collection-count");
      const mobileCount = document.querySelector(".mobile_data .custom-top-collection-count");

      if (updatedCount && mobileCount) {
        mobileCount.textContent = updatedCount.textContent;
      }
    }

    const observer = new MutationObserver(updateMobileCount);
    const targetNode = document.getElementById("ProductGridContainer");

    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
    }

    updateMobileCount();
  });

  function updateTotalPrice() {
    const prices = document.getElementsByClassName("selected_price");
    const values = Array.from(prices).map((input) => parseFloat(input.value) || 0);
    const total = values.reduce((sum, value) => sum + value, 0);

    document.querySelectorAll(".price-item.price-item--regular").forEach((item) => {
      if (item.closest(".price--show-badge")) {
        item.innerText = "$" + total.toFixed(2);
      }
    });
  }

  window.updateTotalPrice = updateTotalPrice;

  function chooseVariant(variantId, optiongroup) {
    const selectedItem = document.querySelector(`.item-id-${variantId}`);
    document.querySelectorAll(".dropdown-list").forEach((dropdownList) => {
      dropdownList.style.display = "none";
    });

    if (!selectedItem) return;

    const selectedText = selectedItem.querySelector("span")?.innerText || "";
    const selectedImage = selectedItem.querySelector("img")?.src || "";

    const selectedDiv = document.querySelector(`.dropdown-selected.show_selected_${optiongroup}`);
    if (selectedDiv) {
      selectedDiv.innerHTML = `
        <img src="${selectedImage}" width="40" height="40" style="margin-right: 10px; border-radius: 5px;">
        ${selectedText}
      `;
    }

    const hiddenInput = document.querySelector(`.attach_selected_id_${optiongroup}`);
    if (hiddenInput) hiddenInput.value = variantId;

    const hiddenInputPrice = document.querySelector(`.attach_selected_price_${optiongroup}`);
    if (hiddenInputPrice) hiddenInputPrice.value = selectedItem.getAttribute("data-price") || "";

    updateTotalPrice();
  }

  window.chooseVariant = chooseVariant;

  function getMultipleProducts(handles, optiongroup) {
    let productList = "";
    const prioritizedHandles = [];
    const regularHandles = [];

    handles.forEach((handle) => {
      const [cleanHandle, priorityFlag] = handle.split("~");
      if (priorityFlag === "true") prioritizedHandles.push({ handle: cleanHandle });
      else regularHandles.push({ handle: cleanHandle });
    });

    const sortedHandles = prioritizedHandles.concat(regularHandles);
    const fetchPromises = sortedHandles.map((h) =>
      fetch(`/products/${h.handle}.json`).then((res) => res.json())
    );

    Promise.all(fetchPromises)
      .then((products) => {
        let firstProductSet = false;

        products.forEach((productData) => {
          if (!productData.product) return;

          const product = productData.product;
          const variant = product.variants[0];

          productList += `
            <li class="dropdown-item item-id-${variant.id}" 
                data-id="${variant.id}"
                onclick="chooseVariant(${variant.id}, '${optiongroup}')"
                data-price="${variant.price}" 
                data-handle="${product.handle}" 
                data-available="true">
              <img src="${product.image ? product.image.src : ""}" alt="${product.title}">
              <span>
                <span class="bundle--main-title">
                  ${product.title}
                  <span class="bundle--price"> | $${variant.price}</span>
                </span>
              </span>
            </li>`;

          if (!firstProductSet) {
            firstProductSet = true;

            const selectedBaseDiv = document.querySelector(".dropdown-selected.show_selected_" + optiongroup);
            if (selectedBaseDiv) {
              selectedBaseDiv.innerHTML = `
                <img src="${product.image ? product.image.src : ""}" width="40" height="40" style="margin-right: 10px; border-radius: 5px;">
                <span class="bundle--main-title">
                  ${product.title}
                  <span class="bundle--price"> | $${variant.price}</span>
                </span>`;
            }

            const hiddenVariantInput = document.querySelector(".attach_selected_id_" + optiongroup);
            if (hiddenVariantInput) hiddenVariantInput.value = variant.id;

            const hiddenVariantInputPrice = document.querySelector(".attach_selected_price_" + optiongroup);
            if (hiddenVariantInputPrice) hiddenVariantInputPrice.value = variant.price;
          }
        });

        const pasteTarget = document.querySelector(".paste-data-bundle-" + optiongroup);
        if (pasteTarget) pasteTarget.innerHTML = productList;
      })
      .catch((error) => console.error("Error fetching products:", error));
  }

  window.getMultipleProducts = getMultipleProducts;

  document.addEventListener("DOMContentLoaded", function () {
    const bundleElements = document.querySelectorAll(".get-data-bundle-comman");

    if (bundleElements.length > 0) {
      bundleElements.forEach((element) => {
        const optionGroup = element.getAttribute("data-group-name-bundle");
        const handles = element.textContent.trim().split(",");
        getMultipleProducts(handles, optionGroup);
      });

      updateTotalPrice();
    }

    document.querySelectorAll(".dropdown-selected").forEach((selectedDiv) => {
      selectedDiv.addEventListener("click", function () {
        const optionGroup = this.getAttribute("data-selected_option");

        document.querySelectorAll(".dropdown-list").forEach((dropdown) => {
          if (!dropdown.classList.contains(`paste-data-bundle-${optionGroup}`)) {
            dropdown.style.display = "none";
          }
        });

        const relatedDropdown = this.nextElementSibling;
        if (relatedDropdown && relatedDropdown.classList.contains("dropdown-list")) {
          relatedDropdown.style.display =
            relatedDropdown.style.display === "block" ? "none" : "block";
        }
      });
    });

    document.addEventListener("click", function (event) {
      if (!event.target.closest(".dropdown-selected") && !event.target.closest(".dropdown-list")) {
        document.querySelectorAll(".dropdown-list").forEach((dropdown) => {
          dropdown.style.display = "none";
        });
      }
    });
  });

  $(document).ready(function () {
    $(".rich-text__heading").click(function () {
      $(".rich-text_collapse").toggleClass("active");
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname !== "/cart") return;

    document.addEventListener(
      "click",
      function (e) {
        const quickBuyButton = e.target.closest(".quick-buy-btn");
        if (!quickBuyButton) return;

        e.preventDefault();
        e.stopPropagation();

        const variantId = quickBuyButton.getAttribute("data-id");
        const quickBuySpan = quickBuyButton.querySelector(".quick_buy");
        const $button = $(quickBuyButton);

        setButtonLoading($button, ".loading__spinner", ".quick_buy", true);

        if (!variantId) {
          console.error("Variant ID not found.");
          setButtonLoading($button, ".loading__spinner", ".quick_buy", false);
          return;
        }

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to add to cart");
            }
            return response.json();
          })
          .then(() => {
            setButtonLoading($button, ".loading__spinner", ".quick_buy", false);
            window.location.reload();
          })
          .catch((error) => {
            console.error(error);
            if (quickBuySpan) quickBuySpan.style.display = "inline";
            setButtonLoading($button, ".loading__spinner", ".quick_buy", false);
            showATCErrorPopup("The maximum quantity of this product is already in your cart.");
          });
      },
      true
    );
  });

  document.addEventListener("DOMContentLoaded", function () {
    const currentParams = new URLSearchParams(window.location.search);
    const currentSize = currentParams.get("filter.p.m.ols.size");

    document.querySelectorAll(".size-filter-item .view_btn").forEach((btn) => {
      const btnUrl = new URL(btn.href, window.location.origin);
      const btnSize = btnUrl.searchParams.get("filter.p.m.ols.size");

      if (btnSize === currentSize) {
        btn.textContent = "Selected";
        btn.classList.add("selected");
      } else {
        btn.textContent = "View";
        btn.classList.remove("selected");
      }

      btn.addEventListener("click", function (e) {
        if (btnSize === currentSize) {
          e.preventDefault();
          window.location.href = window.location.pathname;
        }
      });
    });
  });

  function copyDesktopToMobileAccordion() {
    const desktop = document.querySelector(".product_accordian_content.desktop_accord");
    const mobile = document.querySelector(".product_accordian_content.mobile_accord");

    if (desktop && mobile) {
      mobile.innerHTML = desktop.innerHTML;
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const overlay = document.querySelector(".new-menu-overlay");
    if (overlay) overlay.innerHTML = "";
  });

  document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.querySelector(".satisfaction_guarantee");
    if (!wrapper) return;

    const icon = wrapper.querySelector(".tooltip-icon");
    if (!icon) return;

    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    if (isTouchDevice) {
      ["touchstart", "click"].forEach((evt) => {
        icon.addEventListener(evt, function (e) {
          e.preventDefault();
          e.stopPropagation();
          wrapper.classList.toggle("show-tooltip");
        });
      });

      ["touchstart", "click"].forEach((evt) => {
        document.addEventListener(evt, function (e) {
          if (!wrapper.contains(e.target)) {
            wrapper.classList.remove("show-tooltip");
          }
        });
      });
    } else {
      wrapper.addEventListener("mouseenter", function () {
        wrapper.classList.add("show-tooltip");
      });

      wrapper.addEventListener("mouseleave", function () {
        wrapper.classList.remove("show-tooltip");
      });
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("searchInput");
    const searchButton = document.querySelector(".search__button_predictive");
    const errorMessage = document.querySelector(".form_submit_error");
    const predictiveSearch = document.querySelector("predictive-search");
    const form = searchInput ? searchInput.closest("form") : null;

    if (!searchInput) return;

    let inactivityTimer;

    function clearError() {
      predictiveSearch?.classList.remove("empty-search");
      if (errorMessage) errorMessage.style.display = "none";
    }

    function startInactivityTimer() {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(clearError, 5000);
    }

    if (errorMessage) errorMessage.style.display = "none";

    searchButton?.addEventListener("click", function (e) {
      const searchValue = searchInput.value.trim();
      if (searchValue === "") {
        e.preventDefault();
        predictiveSearch?.classList.add("empty-search");
        if (errorMessage) errorMessage.style.display = "flex";
        startInactivityTimer();
      } else {
        clearError();
      }
    });

    searchInput.addEventListener("input", function (e) {
      const value = searchInput.value.trim();
      if (value === "") {
        e.stopImmediatePropagation?.();
        predictiveSearch?.classList.add("empty-search");
        if (errorMessage) errorMessage.style.display = "flex";
        clearError();
      } else {
        clearError();
      }
    });

    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && searchInput.value.trim() === "") {
        e.preventDefault();
      }
    });

    form?.addEventListener("submit", function (e) {
      if (searchInput.value.trim() === "") {
        e.preventDefault();
        predictiveSearch?.classList.add("empty-search");
        if (errorMessage) errorMessage.style.display = "flex";
        startInactivityTimer();
      }
    });

    document.addEventListener("click", function (event) {
      const isClickInside =
        predictiveSearch?.contains(event.target) || searchInput?.contains(event.target);

      if (!isClickInside) clearError();
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const input = document.querySelector(".search__input.field__input");
    const predictiveSearch = document.querySelector("predictive-search");
    const placeholder = document.querySelector(".placeholder-text");

    if (!input || !predictiveSearch || !placeholder) return;

    let currentIndex = -1;
    let lastTyped = "";

    input.addEventListener("input", () => {
      currentIndex = -1;
      lastTyped = input.value;
      placeholder.style.display = lastTyped.trim() !== "" ? "none" : "block";
    });

    input.addEventListener("keydown", function (e) {
      const suggestions = Array.from(
        predictiveSearch.querySelectorAll('[role="option"]')
      ).filter((el) => {
        const labelEl = el.querySelector(".predictive-search__item-heading, .predictive-search__item, a, span");
        if (!labelEl) return false;
        const text = labelEl.textContent.trim().toLowerCase();
        return text && !text.startsWith("search for");
      });

      if (suggestions.length === 0) return;

      if (["ArrowDown", "ArrowRight"].includes(e.key)) {
        e.preventDefault();
        currentIndex = (currentIndex + 1) % suggestions.length;
        fillWithSuggestion(suggestions, currentIndex);
      } else if (["ArrowUp", "ArrowLeft"].includes(e.key)) {
        e.preventDefault();
        currentIndex = currentIndex <= 0 ? suggestions.length - 1 : currentIndex - 1;
        fillWithSuggestion(suggestions, currentIndex);
      }
    });

    function fillWithSuggestion(suggestions, index) {
      suggestions.forEach((el) => el.setAttribute("aria-selected", "false"));
      const selected = suggestions[index];
      selected.setAttribute("aria-selected", "true");

      const labelEl = selected.querySelector(".predictive-search__item-heading, .predictive-search__item, a, span");
      if (!labelEl) return;

      const suggestionText = labelEl.textContent.trim();
      placeholder.style.display = "none";

      if (suggestionText.toLowerCase().startsWith(lastTyped.toLowerCase())) {
        input.value = suggestionText;
        input.setSelectionRange(lastTyped.length, suggestionText.length);
      } else {
        input.value = suggestionText;
        input.setSelectionRange(0, suggestionText.length);
      }
    }
  });

  $(document).ready(function () {
    $(".more-button").click(function () {
      $(".expandable_content").css("display", "block");
      $(".more-button").css("display", "none");
      $(".less-button").css("display", "block");
    });

    $(".less-button").click(function () {
      $(".expandable_content").css("display", "none");
      $(".more-button").css("display", "block");
      $(".less-button").css("display", "none");

      if (window.innerWidth <= 768) {
        document.getElementById("expand_section")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".thumbnail__badge.video_play").forEach(function (badge) {
      badge.addEventListener("click", function (e) {
        e.preventDefault();
        const button = badge.closest("li")?.querySelector("button.thumbnail");
        if (!button) return;

        button.click();

        if (button.getAttribute("aria-current") === "true") {
          badge.style.display = "none";
        } else {
          badge.style.display = "block";
        }
      });
    });
  });

  $(document).on("click", ".quick-buy-now", function () {
    const $button = $(this);
    const productId = $button.data("id");
    const productQty = $button.data("product-qty") || 1;

    if (!productId) {
      console.log("Variant ID not found.");
      return;
    }

    setButtonLoading($button, ".loading__spinner", ".quick_buy", true);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: productId,
        quantity: productQty,
      },
      dataType: "json",
      success: function () {
        setButtonLoading($button, ".loading__spinner", ".quick_buy", false);
        window.location.href = "/checkout";
      },
      error: function (xhr) {
        console.error("Quick buy failed", xhr);
        setButtonLoading($button, ".loading__spinner", ".quick_buy", false);
      },
    });
  });

  function checkAndClearLoader() {
    document.querySelectorAll(".quick-buy-now, .quick-buy-btn").forEach((button) => {
      const spinner = button.querySelector(".loading__spinner");
      const text = button.querySelector(".quick_buy, .text-button");
      if (spinner) spinner.classList.add("hidden");
      if (text) text.classList.remove("no_visibility");
    });
  }

  window.checkAndClearLoader = checkAndClearLoader;

  window.addEventListener("pageshow", checkAndClearLoader);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      setTimeout(function () {
        checkAndClearLoader();
      }, 50);
    }
  });
  window.addEventListener("load", checkAndClearLoader);

  $(document).ready(function () {
    function getAppliedCoupons() {
      const currentUrl = new URL(window.location.href);
      const existingCodes = currentUrl.searchParams.get("discount");
      return existingCodes ? existingCodes.split(",") : [];
    }

    function updateCouponDisplay() {
      const coupons = getAppliedCoupons();
      const couponList = $(".applied-coupons");
      couponList.empty();

      if (coupons.length > 0) {
        coupons.forEach(function (code) {
          couponList.append(
            `<li>${code} <a href="javascript:void(0)" class="remove_coupon" data-code="${code}">✖</a></li>`
          );
        });
        $(".coupon-container").show();
      } else {
        $(".coupon-container").hide();
      }
    }

    $(document).on("click", ".add_coupon", function () {
      $(".cancel_coupon, .cart-form.coupon-code").show();
      $(".add_coupon").hide();
    });

    $(document).on("click", ".cancel_coupon", function () {
      $(".cancel_coupon, .cart-form.coupon-code").hide();
      $(".add_coupon").show();
    });

    $(document).on("click", ".apply_coupon", function () {
      const couponCode = $("#coupon_code").val().trim();

      if (couponCode === "") {
        alert("Please enter a coupon code.");
        return;
      }

      const appliedCoupons = getAppliedCoupons();
      if (appliedCoupons.includes(couponCode)) {
        alert("This coupon is already applied.");
        return;
      }

      appliedCoupons.push(couponCode);
      window.location.href = "/checkout?discount=" + encodeURIComponent(appliedCoupons.join(","));
    });

    $(document).on("click", ".remove_coupon", function () {
      const removeCode = $(this).data("code");
      const appliedCoupons = getAppliedCoupons().filter((code) => code !== removeCode);

      window.location.href = "/checkout?discount=" + encodeURIComponent(appliedCoupons.join(","));
    });

    updateCouponDisplay();
  });

  document.addEventListener("DOMContentLoaded", function () {
    startTypeEffect("searchLabel", [
      "Commercial Flags",
      "Stick Flags",
      "Residential Flagpoles",
      "American Flags",
    ]);

    window.collection_search();
    cloneRelatedProducts();
    initFooterAccordion();
    initMobileAccButtons();
    copyDesktopToMobileAccordion();
    initializeProductRecommendSwiper();
    initializePeopleAlsoBoughtSwiper();
    initializeYouMayAlsoLikeSwiper();
    window.initializeBestSellerswiper();
    window.initializeCartAddOnSwiper();
  });
})();